import _defaultTheme from "./lib/public/default-theme";
var exports = {};
let defaultTheme = _defaultTheme;
exports = (defaultTheme.__esModule ? defaultTheme : {
  default: defaultTheme
}).default;
export default exports;